import { useState, useCallback } from 'react';
import { FilterItemInfo } from '@/features/connect-dots/types/SelectedFilterItemsContextType';

export function useSelectedFilterItemsImpl(
  initialNodes: FilterItemInfo[] = []
) {
  const [selectedFilterItems, setSelectedFilterItems] =
    useState<FilterItemInfo[]>(initialNodes);

  const addNode = useCallback((node: FilterItemInfo) => {
    setTimeout(() => {
      setSelectedFilterItems((prev) =>
        prev.some(
          (n) =>
            n.nodeType === node.nodeType &&
            n.name === node.name &&
            n.mode === node.mode &&
            n.hasSelected === node.hasSelected
        )
          ? prev
          : [...prev, node]
      );
    }, 0);
  }, []);

  const removeNode = useCallback((node: FilterItemInfo) => {
    setTimeout(() => {
      setSelectedFilterItems((prev) =>
        prev.filter(
          (n) =>
            !(
              n.nodeType === node.nodeType &&
              n.name === node.name &&
              n.mode === node.mode &&
              n.hasSelected === false
            )
        )
      );
    }, 0);
  }, []);
  const clearNodes = useCallback(() => {
    setTimeout(() => {
      setSelectedFilterItems([]);
    }, 0);
  }, []);
  return { selectedFilterItems, addNode, removeNode, clearNodes };
}
